/**
 * Rede de segurança das telas: se uma tela quebrar (erro de programa ou um pedaço
 * do site que não baixou), em vez de a página ficar em branco aparece um aviso,
 * e o topo (com o botão "Relatar") continua lá. O erro vai junto no próximo relato.
 *
 * Lê: nada. Anota o erro em dados/api.ts (ultimoErroDaApi).
 * Usado por: App.tsx (em volta da tela aberta; trocar de tela tenta de novo).
 */
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { anotarErro, ErroApi } from '../dados/api.ts';
import { Aviso } from './basicos.tsx';

interface Estado {
  erro: Error | null;
}

export class LimiteDeErro extends Component<{ children: ReactNode }, Estado> {
  state: Estado = { erro: null };

  static getDerivedStateFromError(erro: Error): Estado {
    return { erro };
  }

  componentDidCatch(erro: Error, info: ErrorInfo): void {
    anotarErro(new ErroApi('TELA', `${erro.message}${info.componentStack ? ` | ${info.componentStack.trim().split('\n')[0]}` : ''}`, 0, null), window.location.hash);
  }

  render() {
    if (!this.state.erro) return this.props.children;
    return (
      <div className="pagina">
        <Aviso tipo="erro">
          Esta tela não abriu. Recarregue a página (F5). Se continuar, toque em <strong>Relatar</strong> e conte o que estava fazendo (o erro vai junto).
          <span className="codigo-erro"> [{this.state.erro.message}]</span>
        </Aviso>
        <div>
          <button type="button" className="botao-secundario" onClick={() => window.location.reload()}>
            Recarregar a página
          </button>
        </div>
      </div>
    );
  }
}
